
    var riot = require('riot')
    //src: starling/src/tags/drawing-menu.html
riot.tag2('drawing-menu',
  '<ul ref="menuList" class="floating-menu_list"> <li class="floating-menu_item" onmouseenter="{openColorPicker}"> <svg class="floating-menu_icon"> <path d="M 0 8 L 40 8" stroke="{getLinePreviewColor(link)}" stroke-dasharray="{getLinePreviewStyle()}" stroke-width="{getLinePreviewWidth()}"></path> </svg> <span class="floating-menu_label">Style</span> <svg class="floating-menu_caret"> <use xlink:href="#caret-right-icon"></use> </svg> <color-picker if="{colorPickerVisible}" positioning="{computeColorPickerPositionStyle()}" colors="{colorProgression}" setcolor="{setColor}" setlinetype="{setStrokeType}" setlinewidth="{setStrokeWidth}" set-opacity="{setOpacity}" drawing-id="{tag && tag.instance.id}" type="drawing"></color-picker> </li> <li class="floating-menu_item--divider"></li> <li class="floating-menu_item" onclick="{deleteDrawing}" onmouseenter="{delayedHideSubMenus}"> <svg class="floating-menu_icon"> <use xlink:href="#delete-icon"></use> </svg> <span class="floating-menu_label">Delete drawing</span> </li> </ul>',
  '',
  'class="floating-menu floating-menu--hidden"', function(opts) {
'use strict';

var _this = this;

var _store_instance = require('../store_instance');

var _store_instance2 = _interopRequireDefault(_store_instance);

var _geom = require('lib/geom.js');

var _constants = require('lib/constants');

var _constants2 = require('lib/constants.js');

var _perspectivesUi = require('lib/perspectives-ui');

var _menuUi = require('lib/menu-ui');

var _delayHandler = require('lib/delay-handler');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

this.pui = _perspectivesUi.pui;
this.positionSelf = _menuUi.mui.positionSelf.bind(this);

this.canvas = this.opts.canvas;
this.canvas.drawingMenu = this;
this.store = _store_instance2.default;
this.colorProgression = _constants2.LINK_COLORS;
this.colorPickerVisible = false;
this.menuName = 'drawing-menu';

this.on('mount', function () {
  $(_this.refs.menuList).on('mousedown touchstart pointerdown', function (e) {
    e.stopImmediatePropagation();
  });
});

this.summon = function (_ref) {
  var x = _ref.x,
      y = _ref.y,
      tag = _ref.tag;

  var _canvas$getMatrix = _this.canvas.getMatrix(),
      scale = _canvas$getMatrix.scale,
      tx = _canvas$getMatrix.tx,
      ty = _canvas$getMatrix.ty;

  _this.canvas.hidePopups();
  _this.canvas.rightClickMenu.hide();
  _this.x = x;
  _this.y = y;
  _this.sx = (x - tx) / scale;
  _this.sy = (y - ty) / scale;
  _this.summoned = true;
  // this.tag.instance = link;
  _this.tag = tag;
  _this.tag.instance = tag.instance;
  _this.root.classList.remove('floating-menu--hidden');
  _this.update();

  _this.positionSelf({
    selfEl: _this.refs.menuList,
    clickPosition: { x: _this.x, y: _this.y }
  });
};

this.hide = function () {
  _this.summoned = false;
  _this.tag = null;
  _this.colorPickerVisible = false;
  _this.root.classList.add('floating-menu--hidden');
  _this.canvas.nodePerspectivesPanelTag.clearInput();
};

this.deleteDrawing = function (e) {
  e.stopPropagation();
  e.preventDefault();
  drawingUI.deleteDrawing(_this.tag.instance);
  _this.canvas.hidePopups();
  _this.hide();
};

this.setColor = function (color) {
  var canvas = _this.canvas,
      tag = _this.tag;
  var instance = tag.instance;
  var drawingTags = canvas.drawingTags;

  if (drawingTags[instance.id]) {
    var prevColor = instance.color;
    var newColor = _constants2.LINK_COLORS_MAPPING[color] || _constants.DEFAULTS.LINK_COLOR;
    instance.setColor(newColor);
    drawingTags[instance.id].update();

    drawingUI.saveDrawingProperty({
      id: instance.id,
      property: 'color',
      newValue: newColor,
      prevValue: prevColor
    });

    drawingUI.setDefaults({ color: newColor });
  }

  _this.update();
};

this.setStrokeWidth = function (width) {
  var canvas = _this.canvas,
      tag = _this.tag;
  var instance = tag.instance;
  var drawingTags = canvas.drawingTags;

  if (drawingTags[instance.id]) {
    var prevWidth = instance.strokeWidth;
    var newWidth = width;

    instance.setStrokeWidth(newWidth);
    drawingTags[instance.id].update();

    drawingUI.saveDrawingProperty({
      id: instance.id,
      property: 'strokeWidth',
      newValue: newWidth,
      prevValue: prevWidth
    });

    drawingUI.setDefaults({ strokeWidth: newWidth });
  }

  _this.update();
};

this.setOpacity = function (opacity) {
  var canvas = _this.canvas,
      tag = _this.tag;
  var instance = tag.instance;
  var drawingTags = canvas.drawingTags;

  if (drawingTags[instance.id]) {
    var prevOpacity = instance.opacity;
    var newOpacity = opacity;
    instance.setOpacity(newOpacity);
    drawingTags[instance.id].update();

    drawingUI.saveDrawingProperty({
      id: instance.id,
      property: 'opacity',
      newValue: newOpacity,
      prevValue: prevOpacity
    });

    drawingUI.setDefaults({ opacity: newOpacity });
  }

  _this.update();
};

this.setStrokeType = function (type) {
  var canvas = _this.canvas,
      tag = _this.tag;
  var instance = tag.instance;
  var drawingTags = canvas.drawingTags;

  if (drawingTags[instance.id]) {
    var prevType = instance.strokeType;
    var newType = type;
    instance.setStrokeType(newType);
    drawingTags[instance.id].update();

    drawingUI.saveDrawingProperty({
      id: instance.id,
      property: 'strokeType',
      newValue: newType,
      prevValue: prevType
    });
  }

  _this.update();
};

this.delayedHideSubMenus = function (e) {
  e.stopPropagation();
  _delayHandler.delayHandler.initializeDelay({
    action: 'submenus',
    id: 'hide',
    delay: _constants.MENU_OPEN_DELAY,
    callback: function callback() {
      _this.hideSubMenus();
    }
  });
};

this.hideSubMenus = function () {
  _this.canvas.nodePerspectivesPanelTag.hide();
  _this.closeColorPicker();
};

this.openColorPicker = function (e) {
  e.stopPropagation();
  _delayHandler.delayHandler.initializeDelay({
    action: 'submenus',
    id: 'drawgincolor',
    delay: _constants.MENU_OPEN_DELAY,
    callback: function callback() {
      if (_this.colorPickerVisible) return;
      _this.hideSubMenus();
      _this.colorPickerVisible = true;
      _this.update();
    }
  });
};

this.getLinePreviewStyle = function () {
  if (!_this.tag || !_this.tag.instance.lineType) {
    return '';
  }
  var dasharrayValues = {
    'dotted': '4px 4px',
    'dashed': '9px 3px',
    'solid': ''
  };
  return dasharrayValues[_this.tag.instance.lineType] || '';
};

this.getLinePreviewWidth = function () {
  if (!_this.tag || !_this.tag.instance.lineWidth) {
    return 2;
  }
  return _this.tag.instance.lineWidth || 2;
};

this.getLinePreviewColor = function (link) {
  if (link && link.color) {
    return _constants.COLOR_VAR_TO_HEX_MAPPING[link.color];
  } else {
    return _constants.COLOR_VAR_TO_HEX_MAPPING['$gray4'];
  }
};

this.closeColorPicker = function () {
  _this.colorPickerVisible = false;
  _this.update();
};

this.computeColorPickerPositionStyle = function () {
  var width = _this.refs.menuList.getBoundingClientRect().width;
  if (_this.positionSubToLeft) {
    return 'top:0px;right:' + width + 'px';
  } else {
    return 'top:0px;left:' + width + 'px';
  }
};

this.straightenLine = function () {
  if (!_this.tag) return;
  _this.tag.straightenLine();
  _this.hide();
};

this.summonPerspectivesPanel = function (e) {
  e.stopPropagation();
  _delayHandler.delayHandler.initializeDelay({
    action: 'submenus',
    id: 'perspectives',
    delay: _constants.MENU_OPEN_DELAY,
    callback: function callback() {
      _this._summonPerspectivesPanel(e);
    }
  });
};
this._summonPerspectivesPanel = function (e) {
  _this.hideSubMenus(e);
  if (_this.positionSubToLeft) {
    _this.canvas.nodePerspectivesPanelTag.summon({
      tag: _this.tag,
      referenceEl: _this.refs.perspectiveItem,
      isBulkAction: false,
      positionToLeft: true,
      isLink: true
    });
  } else {
    _this.canvas.nodePerspectivesPanelTag.summon({
      tag: _this.tag,
      referenceEl: _this.refs.perspectiveItem,
      isBulkAction: false,
      positionToLeft: false,
      isLink: true
    });
  }
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('drawing-menu')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/drawing-menu.html
// module id = 811
// module chunks = 0